import { hasServiceOrder } from '../../functions/service'
import { useAppSelector } from '../../state/hooks'
import {
  selectCustomFields,
  selectServiceFields,
} from '../../state/slices/currentSale/currentSaleSlice'

/**
 * Hook to check if the current sale has a service order
 * @returns True if the sale contains a service order, false otherwise
 */
export const useSaleHasServiceOrder = (): boolean => {
  const serviceFields = useAppSelector(selectServiceFields)
  const customFields = useAppSelector(selectCustomFields)

  return hasServiceOrder(serviceFields, customFields) ?? false
}
